import React from 'react'
// import Image from '../components/image'
import SEO from '@/components/seo'

// Components
import Landing from '@/components/home/Landing'
import Feature from '@/components/home/Feature'
import Solution from '@/components/home/Solution'
import Contact from '@/components/home/Contact'
import Help from '@/components/home/Help'
import Layout from '@/components/common/Layout'

function Home ({ lang }) {
  return (
    <Layout lang={lang}>
      <SEO title='ReCards' />
      <Landing />
      <Feature />
      <Solution />
      <Help />
      <Contact />
    </Layout>
  )
}

export default Home
